import {Transaction as TransactionModel} from '../../../../models/transaction/transaction';
import {Transaction} from '../../../../../swagger-gen/web-secured/models/transaction';
import {TransactionPageable} from '../../../../models/transaction/transactionResponseList';
import moment from 'moment/moment';
import { environment } from 'src/environments/environment';
import { TransactionPagedList } from 'src/swagger-gen/vnf-secured/models/transaction-paged-list';

export class CustomerAccountTransactionRepoModelMapper {

    static toList(transactionPagedList: TransactionPagedList): TransactionPageable {
        return {
            data: transactionPagedList.list?.map(CustomerAccountTransactionRepoModelMapper.toTransaction) ?? [],
            pageable: {
                offset: transactionPagedList.paging.offset ?? 0,
                totalSize: transactionPagedList.paging.totalItems,
                pageSize: transactionPagedList.paging.curItems,
            }
        };
    }

    static toTransaction(transaction: Transaction): TransactionModel {
        return {
            id: transaction.uid,
            startDate: moment(transaction.startDate).toDate(),
            stationName: transaction.stationName ? transaction.stationName : environment.core.noData,
            pumpNumber: transaction.pumpNumber ? transaction.pumpNumber : environment.core.noData,
            customerAccountName: transaction.subscriptionName ? transaction.subscriptionName : environment.core.noData,
            cardNumber: transaction.cardNumber ? transaction.cardNumber : environment.core.noData,
            duration: transaction.duration,
            energy: transaction.energy ? transaction.energy : environment.core.noData,
            vehiculeName: transaction.vehicleName ? transaction.vehicleName : environment.core.noData,
            volume: transaction.volume,
            volumeUnit: transaction.volumeUnit
        };
    }
}
